import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

/**
 * 광고 배너 컴포넌트
 * @returns JSX.Element
 */
const AdvertisingBanner = () => {
	return (
		<section className="main-free main-section">
			<div className="main-free-inner">
				<div className="title-group">
					<p className="sub">꼭 필요한 기능을 합리적인 가격에 제공!</p>
					<strong className="title">
						<span>2개월 무료체험</span>으로
						<br />
						지금 바로 시작하세요!
					</strong>
				</div>
				<div className="main-free-price">
					<p className="price-desc">한시적 적용</p>
					<ul className="price-card">
						<li className="price-item event">
							<span className="event-label">
								<p>
									무료체험 <em>EVENT</em>
								</p>
							</span>
							<strong className="title">연간 이용권</strong>
							<span>
								<div className="sale">
									<p>
										<strong>1,200,000</strong>
										<span className="label">
											1년 선납 2개월 할인+<span>오픈 프로모션</span>
										</span>
									</p>
								</div>
								<div className="price">
									<p>
										<strong>700,000</strong> 원
									</p>
									<span>(VAT 별도)</span>
								</div>
								{/* <span className="sub">
									신규가입 시 <em>2개월 무료체험</em> 기간 제공!
								</span> */}
							</span>
						</li>
						<li className="price-item">
							<span className="event-label">
								<p>
									무료체험 <em>EVENT</em>
								</p>
							</span>
							<strong className="title">월간 이용권</strong>
							<span>
								<div className="sale">
									<p>
										<strong>100,000</strong>
										<span className="label">
											<span>오픈 프로모션</span>
										</span>
									</p>
								</div>
								<div className="price">
									<p>
										<strong>70,000</strong> 원
									</p>
									<span>(VAT 별도)</span>
								</div>
								{/* <span className="sub">
									신규가입 시 <em>2개월 무료체험</em> 기간 제공!
								</span> */}
							</span>
						</li>
					</ul>

					<p className="desc">※ 무료체험 2개월은 가입 월 포함 익월 말까지 적용됩니다.</p>
				</div>
				<Link className="promotion-infomation" to={NAV_PATH.PROMOTION}></Link>
				<Link to={NAV_PATH.PRICE} className="btn primary">
					가격정책 바로가기
				</Link>
			</div>
		</section>
	);
};

export default AdvertisingBanner;
